// extracted by mini-css-extract-plugin
export var csatScore = "_m4-5";
export var header = "_m4-1";
export var panelWrapper = "_m4-2";
export var postPreview = "_m4-3";
export var rightContent = "_m4-0";
export var wrappingText = "_m4-4";